export function ChaptersIcon() {
  return (
    <svg width="24" height="24" fill="currentColor" data-testid="chapters-icon" aria-hidden="true" role="img">
      <path d="M2 13.6h2.22222v-2.2H2v2.2ZM2 18h2.22222v-2.2H2V18Zm0-8.8h2.22222V7H2v2.2Zm4.44444 4.4H22v-2.2H6.44444v2.2Zm0 4.4H22v-2.2H6.44444V18Zm0-11v2.2H22V7H6.44444Z" />
    </svg>
  );
}
